import React from 'react';

export const IconArrowLeft = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            width="24"
            height="24"
            {...props}
        >
            <path
                d="M10.94 7.724a1 1 0 0 0-1.38-1.448l1.38 1.448Zm-6.63 3.552a1 1 0 1 0 1.38 1.448l-1.38-1.448Zm1.38 0a1 1 0 1 0-1.38 1.448l1.38-1.448Zm3.87 6.448a1 1 0 1 0 1.38-1.448l-1.38 1.448ZM5 11a1 1 0 1 0 0 2v-2Zm14 2a1 1 0 1 0 0-2v2ZM9.56 6.276l-5.25 5 1.38 1.448 5.25-5-1.38-1.448Zm-5.25 6.448 5.25 5 1.38-1.448-5.25-5-1.38 1.448ZM5 13h14v-2H5v2Z"
                fill="currentColor"
            />
        </svg>
    );
};

export const IconTrash = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            fill="none"
            height={24}
            viewBox="0 0 24 24"
            width={24}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g fill="currentColor">
                <path
                    clipRule="evenodd"
                    d="m5 9c0-.55228.44772-1 1-1h12c.5523 0 1 .44772 1 1v9c0 2.2091-1.7909 4-4 4h-6c-2.20914 0-4-1.7909-4-4zm2 1v8c0 1.1046.89543 2 2 2h6c1.1046 0 2-.8954 2-2v-8z"
                    fillRule="evenodd"
                />
                <path
                    clipRule="evenodd"
                    d="m13.382 2h-2.764c-.75719.0004-1.44996.42881-1.78857 1.106l-.94765 1.894h-.88178c-.55228 0-1 .44772-1 1s.44772 1 1 1h10c.5523 0 1-.44772 1-1s-.4477-1-1-1h-.8818l-.9479-1.89446c-.3386-.67719-1.0312-1.10514-1.7883-1.10554zm.4998 3-.5001-.99954-2.7632-.00046-.5003 1z"
                    fillRule="evenodd"
                />
                <rect height={6} rx={1} width={2} x={13} y={12} />
                <rect height={6} rx={1} width={2} x={9} y={12} />
            </g>
        </svg>
    );
};

export const IconSend = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g id="send">
                <path
                    id="Union"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.95353 3.77648L20.4772 11.1243C20.6042 11.1938 20.7175 11.2916 20.8065 11.415C20.8302 11.4477 20.8517 11.4816 20.8711 11.5167C20.9562 11.6701 20.9967 11.8368 20.9965 12.0014C20.9967 12.166 20.9562 12.3328 20.871 12.4863C20.8517 12.5212 20.8302 12.5551 20.8067 12.5877C20.7176 12.7111 20.6043 12.809 20.4772 12.8785L7.95352 20.2263C7.30733 20.6126 6.49633 20.5929 5.86954 20.1751C5.24085 19.7562 4.91039 19.012 5.02114 18.2647L5.03585 18.1654L7.26585 12.0014L5.03585 5.83741L5.02114 5.73816C4.91039 4.9908 5.24085 4.24665 5.86954 3.82766C6.49634 3.40995 7.30734 3.39023 7.95353 3.77648ZM16.3156 11.0015L7.06807 5.57579L9.03096 11.0015H16.3156ZM9.03091 13.0015L7.06807 18.427L16.3154 13.0015H9.03091Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
};

export const IconInfo = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 10C12.5523 10 13 10.4477 13 11V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V11C11 10.4477 11.4477 10 12 10Z"
                fill="currentColor"
            />
            <circle
                cx="12"
                cy="8"
                r="0.5"
                fill="currentColor"
                stroke="currentColor"
            />
        </svg>
    );
};

export const VideoIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <mask id="path-1-inside-1_349_839" fill="white">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 5.99451C3.34315 5.99451 2 7.33765 2 8.99451V16.9945C2 18.6514 3.34315 19.9945 5 19.9945H13C14.6569 19.9945 16 18.6514 16 16.9945V14.7445L18.683 17.0921C19.9762 18.2236 22 17.3053 22 15.587V10.402C22 8.68373 19.9762 7.76537 18.683 8.89689L16 11.2445V8.99451C16 7.33765 14.6569 5.99451 13 5.99451H5Z"
                />
            </mask>
            <path
                d="M16 14.7445L17.317 13.2394L14 10.337V14.7445H16ZM18.683 17.0921L17.366 18.5973L18.683 17.0921ZM18.683 8.89689L20 10.402V10.402L18.683 8.89689ZM16 11.2445H14V15.652L17.317 12.7497L16 11.2445ZM4 8.99451C4 8.44222 4.44772 7.99451 5 7.99451V3.99451C2.23858 3.99451 0 6.23308 0 8.99451H4ZM4 16.9945V8.99451H0V16.9945H4ZM5 17.9945C4.44772 17.9945 4 17.5468 4 16.9945H0C0 19.7559 2.23858 21.9945 5 21.9945V17.9945ZM13 17.9945H5V21.9945H13V17.9945ZM14 16.9945C14 17.5468 13.5523 17.9945 13 17.9945V21.9945C15.7614 21.9945 18 19.7559 18 16.9945H14ZM14 14.7445V16.9945H18V14.7445H14ZM14.683 16.2497L17.366 18.5973L20 15.587L17.317 13.2394L14.683 16.2497ZM17.366 18.5973C19.9523 20.8603 24 19.0236 24 15.587H20L17.366 18.5973ZM24 15.587V10.402H20V15.587H24ZM24 10.402C24 6.96541 19.9523 5.12869 17.366 7.39174L20 10.402L20 10.402H24ZM17.366 7.39173L14.683 9.73935L17.317 12.7497L20 10.402L17.366 7.39173ZM14 8.99451V11.2445H18V8.99451H14ZM13 7.99451C13.5523 7.99451 14 8.44222 14 8.99451H18C18 6.23308 15.7614 3.99451 13 3.99451V7.99451ZM5 7.99451H13V3.99451H5V7.99451Z"
                fill="currentColor"
                mask="url(#path-1-inside-1_349_839)"
            />
        </svg>
    );
};

export const IconBellOff = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            {...props}
        >
            <path
                d="M15.5 19.777C15.5 21.4338 14.1569 22.777 12.5 22.777C10.8431 22.777 9.5 21.4338 9.5 19.777M7.87748 8.66176C6.99088 9.59024 6.5 10.7617 6.5 11.977C6.5 14.2588 5.93413 15.9276 5.22806 17.1217C4.42334 18.4826 4.02098 19.1631 4.03686 19.3256C4.05504 19.5116 4.08852 19.5703 4.23934 19.6806C4.37117 19.777 5.03351 19.777 6.35819 19.777H20.38M12.5 6.77698C12.2071 6.77698 11.9164 6.79554 11.63 6.83191C11.2485 6.88037 11.0577 6.90459 10.8662 6.85255C10.7284 6.81508 10.5206 6.69425 10.4198 6.59301C10.2798 6.45238 10.2492 6.37821 10.188 6.22985C10.0668 5.93618 10 5.61439 10 5.27698C10 3.89627 11.1193 2.77698 12.5 2.77698C13.8807 2.77698 15 3.89627 15 5.27698C15 5.9526 14.732 6.56562 14.2965 7.01554C13.7203 6.85882 13.115 6.77698 12.5 6.77698ZM12.5 6.77698C14.0913 6.77698 15.6174 7.32483 16.7426 8.30002C17.8679 9.27521 18.5 10.5979 18.5 11.977C18.5 12.3117 18.5091 12.6333 18.5264 12.9421M21.5 20.777L3.5 4.77698"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconBellOn = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            {...props}
        >
            <path
                d="M14.9997 19.777C14.9997 21.4338 13.6566 22.777 11.9997 22.777C10.3429 22.777 8.99972 21.4338 8.99972 19.777M13.7962 7.01554C14.2317 6.56562 14.4997 5.9526 14.4997 5.27698C14.4997 3.89627 13.3804 2.77698 11.9997 2.77698C10.619 2.77698 9.49972 3.89627 9.49972 5.27698C9.49972 5.9526 9.76772 6.56562 10.2032 7.01554M17.9997 11.977C17.9997 10.5979 17.3676 9.27521 16.2424 8.30002C15.1171 7.32483 13.591 6.77698 11.9997 6.77698C10.4084 6.77698 8.8823 7.32483 7.75708 8.30002C6.63186 9.27521 5.99972 10.5979 5.99972 11.977C5.99972 14.2588 5.43385 15.9276 4.72778 17.1217C3.92306 18.4826 3.5207 19.1631 3.53659 19.3256C3.55476 19.5116 3.58824 19.5703 3.73906 19.6806C3.87089 19.777 4.53323 19.777 5.85791 19.777H18.1415C19.4662 19.777 20.1286 19.777 20.2604 19.6806C20.4112 19.5703 20.4447 19.5116 20.4629 19.3256C20.4787 19.1631 20.0764 18.4826 19.2717 17.1217C18.5656 15.9276 17.9997 14.2588 17.9997 11.977Z"
                stroke="currentColor"
                strokeWidth="2.1295"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconCopy = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            {...props}
        >
            <path
                d="M8 4.55396H14.3111C16.3024 4.55396 17.2981 4.55396 18.0586 4.94149C18.7277 5.28237 19.2716 5.8263 19.6125 6.49532C20 7.2559 20 8.25155 20 10.2428V16.554M6.84444 20.554H14.0444C15.0401 20.554 15.5379 20.554 15.9182 20.3602C16.2527 20.1897 16.5247 19.9178 16.6951 19.5833C16.8889 19.203 16.8889 18.7052 16.8889 17.7095V10.5095C16.8889 9.51386 16.8889 9.01604 16.6951 8.63575C16.5247 8.30124 16.2527 8.02927 15.9182 7.85883C15.5379 7.66507 15.0401 7.66507 14.0444 7.66507H6.84444C5.8488 7.66507 5.35097 7.66507 4.97068 7.85883C4.63617 8.02927 4.36421 8.30124 4.19377 8.63575C4 9.01604 4 9.51386 4 10.5095V17.7095C4 18.7052 4 19.203 4.19377 19.5833C4.36421 19.9178 4.63617 20.1897 4.97068 20.3602C5.35097 20.554 5.8488 20.554 6.84444 20.554Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconClose = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <rect
                x="18.364"
                y="4.72192"
                width="2"
                height="20"
                rx="1"
                transform="rotate(45 18.364 4.72192)"
                fill="currentColor"
            />
            <rect
                x="4.22192"
                y="6.13599"
                width="2"
                height="20"
                rx="1"
                transform="rotate(-45 4.22192 6.13599)"
                fill="currentColor"
            />
        </svg>
    );
};

export const IconCall = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <path
                d="M14.5714 2V3.4C14.5714 3.96005 14.5714 4.24008 14.478 4.45399C14.3958 4.64215 14.2647 4.79513 14.1034 4.89101C13.9201 5 13.68 5 13.2 5H10.8C10.32 5 10.0799 5 9.89658 4.89101C9.7353 4.79513 9.60417 4.64215 9.52199 4.45399C9.42857 4.24008 9.42857 3.96005 9.42857 3.4V2M8.74286 22H15.2571C16.2172 22 16.6973 22 17.064 21.782C17.3865 21.5903 17.6488 21.2843 17.8132 20.908C18 20.4802 18 19.9201 18 18.8V5.2C18 4.07989 18 3.51984 17.8132 3.09202C17.6488 2.71569 17.3865 2.40973 17.064 2.21799C16.6973 2 16.2172 2 15.2571 2H8.74286C7.78277 2 7.30272 2 6.93602 2.21799C6.61345 2.40973 6.3512 2.71569 6.18685 3.09202C6 3.51984 6 4.0799 6 5.2V18.8C6 19.9201 6 20.4802 6.18685 20.908C6.3512 21.2843 6.61345 21.5903 6.93602 21.782C7.30272 22 7.78277 22 8.74286 22Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconElipsis = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            {...props}
        >
            <path
                d="M18 9.5C18 4.80558 14.1944 1 9.5 1C4.80558 1 0.999999 4.80558 1 9.5C1 14.1944 4.80558 18 9.5 18C14.1944 18 18 14.1944 18 9.5Z"
                fill="currentColor"
                stroke="white"
                strokeWidth="2"
            />
        </svg>
    );
};

export const VideoTypeIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            {...props}
        >
            <rect width="40" height="40" rx="8" fill="#D8F1FF" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.3334 12.667C10.6765 12.667 9.33337 14.0101 9.33337 15.667V24.3337C9.33337 25.9905 10.6765 27.3337 12.3334 27.3337H21C22.6569 27.3337 24 25.9905 24 24.3337V15.667C24 14.0101 22.6569 12.667 21 12.667H12.3334ZM25.0008 19.0473L29.3822 15.6048C30.0383 15.0893 31 15.5567 31 16.3911V23.2762C31 24.1106 30.0383 24.578 29.3822 24.0625L25.0008 20.62C24.4912 20.2196 24.4912 19.4477 25.0008 19.0473Z"
                fill="#33B6FF"
            />
        </svg>
    );
};

export const TextTypeIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            {...props}
        >
            <rect width="30" height="30" rx="8" fill="#D8F1FF" />
            <mask id="path-2-inside-1_2849_7201" fill="white">
                <path d="M17 9C19.6454 9 21.809 11.2297 21.9863 14.0518H22C22 14.1257 21.9984 14.1996 21.9961 14.2734C21.9974 14.3241 22 14.3748 22 14.4258C22 16.7806 20.6174 18.7844 18.6855 19.5352C18.4195 19.6576 18.1375 19.7651 17.8379 19.8525C15.0001 20.6813 11.7109 21 9.61523 21C8.99565 21 8.58933 20.7031 8.53809 20.3623C8.48277 19.9943 8.51046 19.7241 8.74902 19.5068C8.77437 19.4838 8.80137 19.4599 8.8291 19.4355C9.17872 19.1285 9.34567 18.9733 9.3457 18.4502C9.3457 18.3103 9.30592 18.1638 9.24219 18.0039C8.46945 17.0487 8 15.7968 8 14.4258C8 14.3742 8.00161 14.3228 8.00293 14.2715C8.00058 14.1995 8.00001 14.1262 8 14.0518H8.01367C8.19099 11.2297 10.3546 9 13 9H17Z" />
            </mask>
            <path
                d="M17 9C19.6454 9 21.809 11.2297 21.9863 14.0518H22C22 14.1257 21.9984 14.1996 21.9961 14.2734C21.9974 14.3241 22 14.3748 22 14.4258C22 16.7806 20.6174 18.7844 18.6855 19.5352C18.4195 19.6576 18.1375 19.7651 17.8379 19.8525C15.0001 20.6813 11.7109 21 9.61523 21C8.99565 21 8.58933 20.7031 8.53809 20.3623C8.48277 19.9943 8.51046 19.7241 8.74902 19.5068C8.77437 19.4838 8.80137 19.4599 8.8291 19.4355C9.17872 19.1285 9.34567 18.9733 9.3457 18.4502C9.3457 18.3103 9.30592 18.1638 9.24219 18.0039C8.46945 17.0487 8 15.7968 8 14.4258C8 14.3742 8.00161 14.3228 8.00293 14.2715C8.00058 14.1995 8.00001 14.1262 8 14.0518H8.01367C8.19099 11.2297 10.3546 9 13 9H17Z"
                fill="#33B6FF"
            />
            <path
                d="M17 9V8.625V9ZM21.9863 14.0518L21.6121 14.0753L21.6341 14.4268H21.9863V14.0518ZM22 14.0518L22.375 14.0518L22.375 13.6768H22V14.0518ZM21.9961 14.2734L21.6213 14.2615L21.6209 14.2722L21.6212 14.283L21.9961 14.2734ZM22 14.4258H22.375V14.4258L22 14.4258ZM18.6855 19.5352L18.5497 19.1856L18.5391 19.1898L18.5287 19.1945L18.6855 19.5352ZM17.8379 19.8525L17.943 20.2125L17.943 20.2125L17.8379 19.8525ZM9.61523 21L9.61521 21.375H9.61523V21ZM8.53809 20.3623L8.16725 20.418L8.16726 20.4181L8.53809 20.3623ZM8.74902 19.5068L8.49664 19.2295L8.49654 19.2296L8.74902 19.5068ZM8.8291 19.4355L8.58163 19.1538L8.58162 19.1538L8.8291 19.4355ZM9.3457 18.4502L9.7207 18.4502V18.4502H9.3457ZM9.24219 18.0039L9.59053 17.8651L9.56949 17.8123L9.53373 17.7681L9.24219 18.0039ZM8 14.4258L7.625 14.4258V14.4258H8ZM8.00293 14.2715L8.37781 14.2812L8.37809 14.2702L8.37773 14.2593L8.00293 14.2715ZM8 14.0518V13.6768H7.62497L7.625 14.0518L8 14.0518ZM8.01367 14.0518V14.4268H8.36585L8.38793 14.0753L8.01367 14.0518ZM13 9V8.625V9ZM17 9V9.375C19.4203 9.375 21.4454 11.4225 21.6121 14.0753L21.9863 14.0518L22.3606 14.0282C22.1726 11.0369 19.8705 8.625 17 8.625V9ZM21.9863 14.0518V14.4268H22V14.0518V13.6768H21.9863V14.0518ZM22 14.0518L21.625 14.0517C21.625 14.1205 21.6236 14.1902 21.6213 14.2615L21.9961 14.2734L22.3709 14.2854C22.3733 14.2089 22.375 14.1308 22.375 14.0518L22 14.0518ZM21.9961 14.2734L21.6212 14.283C21.6229 14.3474 21.625 14.3803 21.625 14.4258L22 14.4258L22.375 14.4258C22.375 14.3693 22.3719 14.3007 22.371 14.2639L21.9961 14.2734ZM22 14.4258H21.625C21.625 16.636 20.3282 18.4944 18.5497 19.1856L18.6855 19.5352L18.8214 19.8847C20.9066 19.0743 22.375 16.9252 22.375 14.4258H22ZM18.6855 19.5352L18.5287 19.1945C18.2785 19.3097 18.0138 19.4105 17.7328 19.4926L17.8379 19.8525L17.943 20.2125C18.2612 20.1196 18.5604 20.0056 18.8424 19.8758L18.6855 19.5352ZM17.8379 19.8525L17.7328 19.4926C14.9361 20.3093 11.6835 20.625 9.61523 20.625V21V21.375C11.7383 21.375 15.064 21.0533 17.943 20.2125L17.8379 19.8525ZM9.61523 21L9.61526 20.625C9.0751 20.625 8.9193 20.3756 8.90892 20.3065L8.53809 20.3623L8.16726 20.4181C8.25937 21.0306 8.91619 21.3749 9.61521 21.375L9.61523 21ZM8.53809 20.3623L8.90892 20.3066C8.85969 19.979 8.90403 19.8729 9.00151 19.7841L8.74902 19.5068L8.49654 19.2296C8.11689 19.5753 8.10585 20.0095 8.16725 20.418L8.53809 20.3623ZM8.74902 19.5068L9.00141 19.7842C9.02421 19.7634 9.04917 19.7414 9.07659 19.7173L8.8291 19.4355L8.58162 19.1538C8.55357 19.1784 8.52453 19.2041 8.49664 19.2295L8.74902 19.5068ZM8.8291 19.4355L9.07658 19.7173C9.24121 19.5727 9.41901 19.4188 9.54015 19.2167C9.67185 18.9969 9.72068 18.7535 9.7207 18.4502L9.3457 18.4502L8.9707 18.4502C8.97069 18.67 8.93603 18.7657 8.89684 18.8311C8.84709 18.9141 8.76661 18.9913 8.58163 19.1538L8.8291 19.4355ZM9.3457 18.4502H9.7207C9.7207 18.2416 9.66181 18.0439 9.59053 17.8651L9.24219 18.0039L8.89384 18.1428C8.95003 18.2837 8.9707 18.3791 8.9707 18.4502H9.3457ZM9.24219 18.0039L9.53373 17.7681C8.81484 16.8794 8.375 15.7107 8.375 14.4258H8H7.625C7.625 15.8829 8.12407 17.218 8.95064 18.2398L9.24219 18.0039ZM8 14.4258L8.375 14.4258C8.375 14.3804 8.37641 14.3354 8.37781 14.2812L8.00293 14.2715L7.62805 14.2618C7.62681 14.3101 7.625 14.368 7.625 14.4258L8 14.4258ZM8.00293 14.2715L8.37773 14.2593C8.37558 14.1932 8.37501 14.1246 8.375 14.0517L8 14.0518L7.625 14.0518C7.62501 14.1279 7.62559 14.2058 7.62813 14.2837L8.00293 14.2715ZM8 14.0518V14.4268H8.01367V14.0518V13.6768H8V14.0518ZM8.01367 14.0518L8.38793 14.0753C8.55461 11.4225 10.5797 9.375 13 9.375V9V8.625C10.1295 8.625 7.82736 11.0369 7.63941 14.0282L8.01367 14.0518ZM13 9V9.375H17V9V8.625H13V9Z"
                fill="#33B6FF"
                mask="url(#path-2-inside-1_2849_7201)"
            />
        </svg>
    );
};

export const IconCalendar = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.89918 4.48223C7.89918 3.89418 8.37588 3.41748 8.96392 3.41748C9.55197 3.41748 10.0287 3.89418 10.0287 4.48223V5.54698H16.4172V4.48223C16.4172 3.89418 16.8939 3.41748 17.4819 3.41748C18.0699 3.41748 18.5467 3.89418 18.5467 4.48223V5.54698H19.6114C21.9636 5.54698 23.8704 7.45379 23.8704 9.80597V17.2592C23.8704 19.6114 21.9636 21.5182 19.6114 21.5182H6.83443C4.48225 21.5182 2.57544 19.6114 2.57544 17.2592V9.80597C2.57544 7.45379 4.48225 5.54698 6.83443 5.54698H7.89918V4.48223ZM16.4172 7.67647V8.74122C16.4172 9.32926 16.8939 9.80597 17.4819 9.80597C18.0699 9.80597 18.5467 9.32926 18.5467 8.74122V7.67647H19.6114C20.7875 7.67647 21.7409 8.62988 21.7409 9.80597V17.2592C21.7409 18.4353 20.7875 19.3887 19.6114 19.3887H6.83443C5.65834 19.3887 4.70493 18.4353 4.70493 17.2592V9.80597C4.70493 8.62988 5.65834 7.67647 6.83443 7.67647H7.89918V8.74122C7.89918 9.32926 8.37588 9.80597 8.96392 9.80597C9.55197 9.80597 10.0287 9.32926 10.0287 8.74122V7.67647H16.4172Z"
                fill="currentColor"
            />
        </svg>
    );
};

export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1181 11.0591C16.1181 13.8531 13.8531 16.1181 11.0591 16.1181C8.26502 16.1181 6 13.8531 6 11.0591C6 8.26502 8.26502 6 11.0591 6C13.8531 6 16.1181 8.26502 16.1181 11.0591ZM15.3401 16.6723C14.1526 17.5794 12.6688 18.1181 11.0591 18.1181C7.16045 18.1181 4 14.9577 4 11.0591C4 7.16045 7.16045 4 11.0591 4C14.9577 4 18.1181 7.16045 18.1181 11.0591C18.1181 12.6693 17.579 14.1536 16.6714 15.3414L19.7243 18.3943C20.0919 18.7619 20.0919 19.3578 19.7243 19.7254C19.3568 20.093 18.7608 20.093 18.3933 19.7254L15.3401 16.6723Z"
                fill="inherit"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1181 11.0591C16.1181 13.8531 13.8531 16.1181 11.0591 16.1181C8.26502 16.1181 6 13.8531 6 11.0591C6 8.26502 8.26502 6 11.0591 6C13.8531 6 16.1181 8.26502 16.1181 11.0591ZM15.3401 16.6723C14.1526 17.5794 12.6688 18.1181 11.0591 18.1181C7.16045 18.1181 4 14.9577 4 11.0591C4 7.16045 7.16045 4 11.0591 4C14.9577 4 18.1181 7.16045 18.1181 11.0591C18.1181 12.6693 17.579 14.1536 16.6714 15.3414L19.7243 18.3943C20.0919 18.7619 20.0919 19.3578 19.7243 19.7254C19.3568 20.093 18.7608 20.093 18.3933 19.7254L15.3401 16.6723Z"
                fill="inherit"
                fillOpacity="0.2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1181 11.0591C16.1181 13.8531 13.8531 16.1181 11.0591 16.1181C8.26502 16.1181 6 13.8531 6 11.0591C6 8.26502 8.26502 6 11.0591 6C13.8531 6 16.1181 8.26502 16.1181 11.0591ZM15.3401 16.6723C14.1526 17.5794 12.6688 18.1181 11.0591 18.1181C7.16045 18.1181 4 14.9577 4 11.0591C4 7.16045 7.16045 4 11.0591 4C14.9577 4 18.1181 7.16045 18.1181 11.0591C18.1181 12.6693 17.579 14.1536 16.6714 15.3414L19.7243 18.3943C20.0919 18.7619 20.0919 19.3578 19.7243 19.7254C19.3568 20.093 18.7608 20.093 18.3933 19.7254L15.3401 16.6723Z"
                fill="inherit"
                fillOpacity="0.2"
            />
        </svg>
    );
};

export const IconFile = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M14 17H8M16 13H8M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconAddFile = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.5263 20.1818V18.3636H14.7368C14.2427 18.3636 13.8421 17.9566 13.8421 17.4545C13.8421 16.9525 14.2427 16.5455 14.7368 16.5455H16.5263V14.7273C16.5263 14.2252 16.9269 13.8182 17.4211 13.8182C17.9152 13.8182 18.3158 14.2252 18.3158 14.7273V16.5455H20.1053C20.5994 16.5455 21 16.9525 21 17.4545C21 17.9566 20.5994 18.3636 20.1053 18.3636H18.3158V20.1818C18.3158 20.6839 17.9152 21.0909 17.4211 21.0909C16.9269 21.0909 16.5263 20.6839 16.5263 20.1818ZM10.2632 13.8182C10.7573 13.8182 11.1579 14.2252 11.1579 14.7273C11.1579 15.2293 10.7573 15.6364 10.2632 15.6364H8.47369C7.97954 15.6364 7.57895 15.2293 7.57895 14.7273C7.57895 14.2252 7.97954 13.8182 8.47369 13.8182H10.2632ZM13.8421 10.1818C14.3363 10.1818 14.7368 10.5888 14.7368 11.0909C14.7368 11.593 14.3363 12 13.8421 12H8.47369C7.97954 12 7.57895 11.593 7.57895 11.0909C7.57895 10.5888 7.97954 10.1818 8.47369 10.1818H13.8421ZM18.3158 10.6364V7.27255C18.3158 6.49401 18.3155 5.9647 18.2826 5.55558C18.2586 5.25684 18.2195 5.06744 18.1716 4.93146L18.1209 4.81073C17.9708 4.51142 17.7424 4.26097 17.4621 4.08629L17.3389 4.01616C17.199 3.94371 16.9981 3.88448 16.6058 3.85192C16.2032 3.8185 15.6822 3.81818 14.916 3.81818H9.1893C8.42306 3.81818 7.9021 3.8185 7.49944 3.85192C7.20542 3.87633 7.019 3.91602 6.88518 3.96467L6.76635 4.01616C6.47177 4.16868 6.22527 4.40077 6.05335 4.68555L5.98433 4.81073C5.91302 4.95291 5.85473 5.15702 5.82268 5.55558C5.78979 5.9647 5.78948 6.49401 5.78948 7.27255V16.7274C5.78948 17.506 5.78979 18.0353 5.82268 18.4444C5.85473 18.843 5.91302 19.0471 5.98433 19.1893L6.05335 19.3145C6.22527 19.5992 6.47177 19.8313 6.76635 19.9838L6.88518 20.0353C7.019 20.084 7.20542 20.1237 7.49944 20.1481C7.9021 20.1815 8.42306 20.1818 9.1893 20.1818H12.0526C12.5468 20.1818 12.9474 20.5888 12.9474 21.0909C12.9474 21.593 12.5468 22 12.0526 22H9.1893C8.45249 22 7.84596 22.0009 7.35352 21.96C6.91344 21.9235 6.5043 21.8505 6.11801 21.6822L5.95374 21.604C5.36459 21.299 4.8716 20.8348 4.52776 20.2653L4.3897 20.0149C4.16846 19.5737 4.08042 19.1036 4.03932 18.5927C3.99909 18.0923 4 17.4761 4 16.7274V7.27255C4 6.52392 3.99909 5.90766 4.03932 5.40732C4.08042 4.89636 4.16846 4.42627 4.3897 3.98509L4.52776 3.73473C4.8716 3.16518 5.36459 2.701 5.95374 2.39595L6.11801 2.31783C6.5043 2.14947 6.91344 2.07649 7.35352 2.03995C7.84596 1.99907 8.45249 2 9.1893 2H14.916C15.6528 2 16.2593 1.99907 16.7517 2.03995C17.2546 2.08171 17.7173 2.17116 18.1515 2.39595L18.3979 2.53622C18.9585 2.88558 19.4153 3.38648 19.7156 3.98509L19.7925 4.15199C19.9582 4.54448 20.03 4.96018 20.0659 5.40732C20.1062 5.90766 20.1053 6.52392 20.1053 7.27255V10.6364C20.1053 11.1384 19.7047 11.5455 19.2105 11.5455C18.7164 11.5455 18.3158 11.1384 18.3158 10.6364ZM15.6316 6.54546C16.1257 6.54546 16.5263 6.95247 16.5263 7.45455C16.5263 7.95662 16.1257 8.36364 15.6316 8.36364H8.47369C7.97954 8.36364 7.57895 7.95662 7.57895 7.45455C7.57895 6.95247 7.97954 6.54546 8.47369 6.54546H15.6316Z"
                fill="#2E3149"
            />
        </svg>
    );
};
export const IconDotsVertical = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                stroke="#2E3149"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                stroke="#2E3149"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                stroke="#2E3149"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconEdit = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.2167 5.03823C15.0538 4.95828 14.8536 5.00706 14.7468 5.15892C14.7347 5.1761 14.722 5.1929 14.7089 5.20929L13.3564 6.89569L16.2153 9.27812L17.5642 7.59783C17.589 7.56688 17.6157 7.53744 17.644 7.50966C17.705 7.44993 17.7395 7.36831 17.74 7.28298C17.7404 7.20784 17.7144 7.1353 17.667 7.07781L15.2167 5.03823ZM14.9637 10.8385L12.1031 8.45474L6.15565 15.8755L6.01348 18.9452L9.03756 18.2285L14.9637 10.8385ZM11.3755 6.16894C11.3589 6.18682 11.3428 6.20544 11.3273 6.22479L4.5847 14.6376C4.33566 14.9334 4.18757 15.3013 4.16238 15.6876L4.16133 15.7064L4.00107 19.1669C3.99877 19.2166 4.00018 19.2663 4.00528 19.3158C4.10639 20.2961 4.94856 21.0313 5.93359 20.9991C6.00028 20.9969 6.06658 20.988 6.13151 20.9727L9.56568 20.1588L9.58123 20.1549C9.96009 20.0587 10.2984 19.8443 10.5472 19.5428L17.4701 10.91C17.4715 10.9081 17.473 10.9063 17.4744 10.9045L19.0917 8.88982C19.504 8.46142 19.7367 7.89023 19.74 7.29396C19.7434 6.67503 19.4993 6.0804 19.0621 5.64234C19.0404 5.62059 19.0177 5.59986 18.994 5.58021L16.4333 3.44873C16.4015 3.42222 16.368 3.39772 16.3331 3.37536C15.2728 2.69592 13.8688 2.96341 13.1316 3.97931L11.3755 6.16894Z"
                fill="#2E3149"
            />
        </svg>
    );
};
export const IconUsers = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.72727 4.8C8.22104 4.8 7 6.00883 7 7.5C7 8.99117 8.22104 10.2 9.72727 10.2C11.2335 10.2 12.4545 8.99117 12.4545 7.5C12.4545 6.00883 11.2335 4.8 9.72727 4.8ZM5.18182 7.5C5.18182 5.01472 7.21689 3 9.72727 3C12.2377 3 14.2727 5.01472 14.2727 7.5C14.2727 9.98528 12.2377 12 9.72727 12C7.21689 12 5.18182 9.98528 5.18182 7.5ZM14.3391 3.82399C14.5275 3.36325 15.0575 3.14094 15.5229 3.32744C17.1871 3.99433 18.3636 5.61006 18.3636 7.5C18.3636 9.38994 17.1871 11.0057 15.5229 11.6726C15.0575 11.8591 14.5275 11.6368 14.3391 11.176C14.1508 10.7153 14.3753 10.1906 14.8407 10.0041C15.8419 9.60287 16.5455 8.6317 16.5455 7.5C16.5455 6.3683 15.8419 5.39713 14.8407 4.99593C14.3753 4.80942 14.1508 4.28473 14.3391 3.82399ZM8.33134 13.8H11.1232C11.943 13.8 12.6043 13.8 13.1424 13.8363C13.6959 13.8737 14.1852 13.9525 14.6486 14.1425C15.7623 14.5993 16.6472 15.4753 17.1085 16.5779C17.3005 17.0367 17.3801 17.5211 17.4178 18.069C17.4546 18.6018 17.4546 19.2564 17.4545 20.068V20.1C17.4545 20.5971 17.0475 21 16.5455 21C16.0434 21 15.6364 20.5971 15.6364 20.1C15.6364 19.249 15.6359 18.6558 15.6039 18.1915C15.5724 17.7353 15.5136 17.4696 15.4288 17.2668C15.152 16.6052 14.621 16.0796 13.9528 15.8055C13.7479 15.7215 13.4795 15.6633 13.0187 15.6322C12.5497 15.6005 11.9505 15.6 11.0909 15.6H8.36364C7.50403 15.6 6.90486 15.6005 6.43586 15.6322C5.97503 15.6633 5.70667 15.7215 5.50177 15.8055C4.83351 16.0796 4.30259 16.6052 4.02578 17.2668C3.94091 17.4696 3.88212 17.7353 3.85067 18.1915C3.81867 18.6558 3.81818 19.249 3.81818 20.1C3.81818 20.5971 3.41117 21 2.90909 21C2.40701 21 2 20.5971 2 20.1L2 20.068C1.99999 19.2565 1.99999 18.6018 2.03671 18.069C2.07447 17.5211 2.15407 17.0367 2.346 16.5779C2.80734 15.4753 3.69222 14.5993 4.80598 14.1425C5.26935 13.9525 5.75869 13.8737 6.3121 13.8363C6.85028 13.8 7.51156 13.8 8.33134 13.8ZM17.4832 14.5891C17.6084 14.1077 18.104 13.8179 18.5902 13.9418C20.5505 14.4413 22 16.2019 22 18.3V20.1C22 20.5971 21.593 21 21.0909 21C20.5888 21 20.1818 20.5971 20.1818 20.1V18.3C20.1818 17.0431 19.3135 15.9848 18.137 15.685C17.6508 15.5611 17.3581 15.0705 17.4832 14.5891Z"
                fill="#2E3149"
            />
        </svg>
    );
};

export const IconGlobe = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.81883 10.3636C4.69941 10.8899 4.63636 11.4376 4.63636 12C4.63636 12.5624 4.69941 13.1101 4.81883 13.6364H8.04196C7.96521 13.1022 7.92061 12.5616 7.90927 12.017C7.90903 12.0057 7.90903 11.9943 7.90927 11.983C7.92061 11.4384 7.96521 10.8978 8.04196 10.3636H4.81883ZM5.40179 8.72727H8.38297C8.75869 7.35994 9.35089 6.05841 10.1392 4.8735C8.0603 5.4148 6.33882 6.84173 5.40179 8.72727ZM12 5.08702C11.1494 6.18295 10.5043 7.41648 10.089 8.72727H13.911C13.4957 7.41648 12.8506 6.18295 12 5.08702ZM14.3025 10.3636H9.69754C9.60906 10.9021 9.55793 11.4488 9.54564 12C9.55793 12.5512 9.60906 13.0979 9.69754 13.6364H14.3025C14.3909 13.0979 14.4421 12.5512 14.4544 12C14.4421 11.4488 14.3909 10.9021 14.3025 10.3636ZM15.958 13.6364C16.0348 13.1022 16.0794 12.5616 16.0907 12.017C16.091 12.0057 16.091 11.9943 16.0907 11.983C16.0794 11.4384 16.0348 10.8978 15.958 10.3636H19.1812C19.3006 10.8899 19.3636 11.4376 19.3636 12C19.3636 12.5624 19.3006 13.1101 19.1812 13.6364H15.958ZM13.911 15.2727H10.089C10.5043 16.5835 11.1494 17.8171 12 18.913C12.8506 17.8171 13.4957 16.5835 13.911 15.2727ZM10.1392 19.1265C9.35088 17.9416 8.75869 16.6401 8.38297 15.2727H5.40179C6.33882 17.1583 8.0603 18.5852 10.1392 19.1265ZM13.8608 19.1265C14.6491 17.9416 15.2413 16.6401 15.617 15.2727H18.5982C17.6612 17.1583 15.9397 18.5852 13.8608 19.1265ZM18.5982 8.72727H15.617C15.2413 7.35994 14.6491 6.05841 13.8608 4.8735C15.9397 5.4148 17.6612 6.84173 18.5982 8.72727ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
                fill="#2E3149"
            />
        </svg>
    );
};

export const IconRemove = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M13.8235 11.1H8.52941M10.2941 14.7H8.52941M15.5882 7.5H8.52941M19.1176 12V7.32C19.1176 5.80786 19.1176 5.05179 18.8291 4.47423C18.5754 3.96619 18.1704 3.55314 17.6723 3.29428C17.1061 3 16.3648 3 14.8824 3H9.23529C7.7528 3 7.01156 3 6.44532 3.29428C5.94724 3.55314 5.54229 3.96619 5.28851 4.47423C5 5.05179 5 5.80786 5 7.32V16.68C5 18.1921 5 18.9482 5.28851 19.5258C5.54229 20.0338 5.94724 20.4469 6.44532 20.7057C7.01156 21 7.7528 21 9.23529 21H12.0588M15.5882 15.6L20 20.1M20 15.6L15.5882 20.1"
                stroke="#2E3149"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconPhone = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g id="phone-02">
                <path
                    id="Icon"
                    d="M15 2V3.4C15 3.96005 15 4.24008 14.891 4.45399C14.7951 4.64215 14.6422 4.79513 14.454 4.89101C14.2401 5 13.9601 5 13.4 5H10.6C10.0399 5 9.75992 5 9.54601 4.89101C9.35785 4.79513 9.20487 4.64215 9.10899 4.45399C9 4.24008 9 3.96005 9 3.4V2M8.2 22H15.8C16.9201 22 17.4802 22 17.908 21.782C18.2843 21.5903 18.5903 21.2843 18.782 20.908C19 20.4802 19 19.9201 19 18.8V5.2C19 4.07989 19 3.51984 18.782 3.09202C18.5903 2.71569 18.2843 2.40973 17.908 2.21799C17.4802 2 16.9201 2 15.8 2H8.2C7.0799 2 6.51984 2 6.09202 2.21799C5.71569 2.40973 5.40973 2.71569 5.21799 3.09202C5 3.51984 5 4.0799 5 5.2V18.8C5 19.9201 5 20.4802 5.21799 20.908C5.40973 21.2843 5.71569 21.5903 6.09202 21.782C6.51984 22 7.07989 22 8.2 22Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export const CircleSpinner = ({
    circleClassName = 'opacity-25',
    pathClassName = 'opacity-75',
    ...props
}: React.SVGProps<SVGSVGElement> & {
    circleClassName?: string;
    pathClassName?: string;
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <circle
            className={circleClassName}
            cx="12"
            cy="12"
            r="10"
            fill="none"
            stroke="none"
            strokeWidth="4"
        ></circle>
        <path
            className={pathClassName}
            fill="inherit"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
    </svg>
);
